import { combineReducers } from 'redux';
import { fieldsReducer } from './fields.reducer';
import { predictionsReducer } from './predictions.reducer';
import securityReducer from './security.reducer';
import settingsReducer from './settings.reducer';
import { socketsReducer } from './sockets.reducers';
import themesReducer from './themes.reducers';

export default combineReducers({
    fields: fieldsReducer,
    predictions: predictionsReducer,
    security: securityReducer,
    settings: settingsReducer,
    sockets: socketsReducer,
    theme: themesReducer,
});
